export default class ArrayHelper {
  /**
   * @param {boolean} noExtraTransform - If should or not do some extra text transform, like lowercase beginning of each string and removing dots at the end of those.
   */
  static toSentence(array, wordsConnector = ', ', lastWordConnector = ' e ', noExtraTransform = false) {
    if(array.length == 1) return array[0]

    let firstWords = array.slice(0, array.length - 1)
    let lastWord = array[array.length-1]

    if(!noExtraTransform) {
      firstWords = firstWords.map((word, index) => {
        word = word.replace(/[,.]$/, '')
        return index != 0 ? word.replace(/^([A-Z])/, (match) =>  match.toLowerCase()) : word
      })
      lastWord = lastWord.replace(/[,.]$/, '').replace(/^([A-Z])/, (match) =>  match.toLowerCase())
    }
    return Array.join(firstWords, wordsConnector) + lastWordConnector + lastWord
  }
}



// WEBPACK FOOTER //
// ./src/utils/array-helper.js